import { RepaymentPageRecord, RepaymentState } from '@/api/model/repayment'

const mergeableStates = [
    RepaymentState.UNPAID,
    RepaymentState.OVERDUE,
    RepaymentState.PARTIAL
]

export function mergedRepaymentSelectionError(
    records: Array<Pick<RepaymentPageRecord, 'cameraId' | 'cameraIdStr' | 'state'>>
): string {
    if (records.some(record => !mergeableStates.includes(record.state))) {
        return 'repayment.merge.invalidState'
    }
    if (records.length < 2) {
        return ''
    }
    const firstCameraId = records[0].cameraIdStr || String(records[0].cameraId)
    const sameMainBill = records.every(record =>
        (record.cameraIdStr || String(record.cameraId)) === firstCameraId
    )
    return sameMainBill ? '' : 'repayment.merge.sameMainBillRequired'
}

export function selectedRepaymentIds(
    records: Array<Pick<RepaymentPageRecord, 'ridStr'>>
): string[] {
    return records.map(record => record.ridStr)
}
